import AttendanceSerializer from './base';

export default class Expulsion extends AttendanceSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      stage: 0,
      outcome: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
